export class MoleculePanelServiceInfoDatabaseComponent {
    public template = require('./panel-service-info-database.html');
}
